// extracted by mini-css-extract-plugin
export default {"popover":"VGTUSmx6pFmOIlnWyWYQ"};